import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const QRIcon = ({ color = '#B5BCBD', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 2.344v1.562H8.437V2.344H10zm-1.563 9.18v2.226H10v-2.227H8.437zM13.125 20v-1.563h-1.563v-1.562H10V20h3.125zM16.25 8.398h-4.688v1.563h4.688V8.398zm0 3.125h2.188V9.961H16.25v1.562zm0 2.227v1.563H20v-3.79h-1.563v2.227H16.25zM11.562 0H10v2.344h1.563V0zM10 7.031h1.563V3.906H10V5.47H8.437V9.96H10V7.03zM0 8.398v3.125h1.563V9.961h2.343V8.398H0zm11.563 3.125V9.961H10v1.562h1.563zm3.124 1.563h1.563v-1.563h-1.563v1.563zm3.75-3.125H20V8.398h-1.563v1.563zm-5.312 1.562h-1.563v2.227H10v1.563h3.125v-3.79zm-4.688 5.352H10v-1.563H8.437v1.563zm4.688-1.563v1.563h3.125v-1.563h-3.125zm4.688 3.126v-1.563H16.25v1.563h1.563zM20 20v-1.563h-2.188V20H20zm-5.313 0h1.563v-1.563h-1.563V20zM7.032 9.96V8.399H5.47v1.563H3.906v1.562h4.531V9.961H7.032zm0-2.929H0V0h7.031v7.031zM5.47 1.563H1.562v3.906H5.47V1.562zM4.297 2.734H2.734v1.563h1.563V2.734zM20 0v7.031h-7.031V0H20zm-1.563 1.563h-3.906v3.906h3.906V1.562zm-1.171 1.171h-1.563v1.563h1.563V2.734zM0 12.97h7.031V20H0v-7.031zm1.563 5.469h3.906V14.53H1.562v3.906zm1.171-1.172h1.563v-1.563H2.734v1.563z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

QRIcon.propTypes = propTypes;

export default QRIcon;
